import React, { useRef, useState } from "react";
import classes from "./municipalitymain.module.scss";
import MainLayout from "../common/MainLayout";
import userEditorIcon from "../../assets/icons/userEditorIcon.svg";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionDeleteMunicipalityDataApiCall } from "../../Redux/Actions";
import OffcanvasMain from "../common/Offcanvas";
import MunicipalityHeader from "../common/MunicipalityHeader";
import MunicipalityForm from "../common/MunicipalityForm";
import { useNavigate } from "react-router-dom";
const MunicipalityMain = () => {
  const tableData = useSelector(
    (state) => state?.CommonReducer?.getMunicipalityTable
  );

  const dispatch = useDispatch();
  const [editData, setEditData] = useState();
  const [ind, setInd] = useState("");
  const listRef = useRef(null);
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const divref = useRef([]);
  const [openCanvas, setOpenCanvas] = useState(false);
  const navigate = useNavigate();
  const handleScroll = (index) => {
    let ref = divref.current[index];
    const y = ref.getBoundingClientRect().top;
    if (y > 303) {
      divref.current[index].scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = (item) => {
    dispatch(actionDeleteMunicipalityDataApiCall({ id: item?.id, navigate }));
  };

  return (
    <React.Fragment>
      <MainLayout>
        <div className={classes.CountriesMain}>
          <MunicipalityHeader editData={editData} />
          <div className={classes.CountriesSection}>
            <table>
              <thead>
                <tr>
                  <th>{t("name")}</th>
                  <th>{t("code").toUpperCase()}</th>
                  <th>{t("country_part").toUpperCase()}</th>
                  <th>{t("province").toUpperCase()}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((item, index) => (
                    <tr ref={(e) => (divref.current[index] = e)} key={index}>
                      <td>{item?.name}</td>
                      <td>{item?.code ? item?.code : "-"}</td>
                      <td>
                        {item?.country_part ? item?.country_part?.name : "-"}
                      </td>
                      <td>{item?.province ? item?.province?.name : "-"}</td>

                      <td className={classes.userEditor}>
                        <img
                          src={userEditorIcon}
                          onClick={() => {
                            handleScroll(index);
                            if (ind !== index) {
                              setShow(!show);
                              setInd(index);
                            } else {
                              setInd("");
                            }
                          }}
                        />
                        {show && ind === index && (
                          <div
                            ref={listRef}
                            className={classes.EditorWrap}
                            onClick={() => setShow(!show)}
                            style={
                              tableData.length - 1 > index
                                ? {}
                                : tableData.length > 4
                                ? { top: "-100px" }
                                : {}
                            }
                          >
                            <ul>
                              <li
                                onClick={() => {
                                  setOpenCanvas(true);
                                  setEditData(item);
                                }}
                              >
                                {t("edit")} {t("municipality")}
                              </li>
                              <li onClick={() => handleDelete(item)}>
                                {t("delete")} {t("municipality")}
                              </li>
                            </ul>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className={classes.LoaderWrap} colSpan={6}>
                      <h2>{t("no_data_found")}</h2>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <OffcanvasMain
            showcanvas={openCanvas}
            placement={"end"}
            backgroundColor="true"
            handleClose={() => {
              setOpenCanvas(false);
            }}
          >
            <MunicipalityForm
              editData={editData}
              handleClose={() => {
                setOpenCanvas(false);
              }}
            />
          </OffcanvasMain>
        </div>
      </MainLayout>
    </React.Fragment>
  );
};

export default MunicipalityMain;
